<div class="card-section">
    <div class="head-wrapper">
        <div class="member-name"> {{memberSchedules.firstName}} {{memberSchedules.lastName}} </div>
        <div class="btn-wrapper">
            <div tooltipStyleClass="notes-tooltip" *ngIf="memberSchedules?.notes"
                [escape]="false"
                pTooltip="<div class='tooltip-wrapper'><h5>Notes</h5> {{memberSchedules?.notes}} </div>"
                tooltipPosition="bottom" placeholder="Bottom">
                <div class="icon"><img src="/assets/images/temp/note.svg" alt="note icon" /></div>
            </div>
            <div class="icon" (click)="editSlot()" pTooltip="Manage shift" tooltipPosition="top"
            tooltipStyleClass="custom-tooltip"
                *ngIf="!memberSchedules?.fullDayOff && !isPastDate"><img
                    src="/assets/images/temp/edit_availability.svg" alt="edit icon" /></div>
            <div class="icon" (click)="addTimeOff()" pTooltip="Add Time Off" tooltipPosition="top"
            tooltipStyleClass="custom-tooltip"
                *ngIf="!memberSchedules?.leaveType && !isPastDate"><img src="/assets/images/temp/add_time_off.svg"
                    alt="add timeoff icon" /></div>
            <div class="icon" (click)="confirmCancelLeave()"
                *ngIf="memberSchedules?.memberSchedules[0]?.memberStatusStr !== 'Unavailable' && memberSchedules?.leaveType && !isPastDate">
                <img src="/assets/images/temp/cancel_leave.svg" alt="apply leave icon" />
            </div>
        </div>
    </div>
    <div class="body-wrapper">
        <div class="slot-card" [ngClass]="schedule?.leaveTypeId === '0' ? 'available' : 'unavailable'" 
        *ngFor="let schedule of memberSchedules?.memberSchedules[0]?.userTeams">
            <span class="text" *ngIf="schedule.leaveType  && !schedule?.fullDayOff"><span
                    class="text bold">{{schedule?.teamName ? schedule?.teamName  : (memberSchedules?.userType === 'Mobile' ?
                    'Mobile User' : 'Web User') }} - </span><span
                    class="text red-text">{{schedule?.leaveType}}
                    ({{ schedule?.slotTimeStr}})</span></span>

            <span class="text" *ngIf="schedule.leaveType && schedule?.fullDayOff"><span
                    class="text bold">{{schedule?.teamName ? schedule?.teamName : (memberSchedules?.userType === 'Mobile' ?
                    'Mobile User' : 'Web User') }} - </span><span
                    class="text red-text">{{schedule?.leaveType}} (All
                    Day)</span></span>

            <span class="text" *ngIf="!schedule?.leaveType"><span class="text bold">{{schedule?.teamName ? schedule?.teamName : (memberSchedules?.userType === 'Mobile' ?
                'Mobile User' : 'Web User') }} - </span><span
                    class="text">
                    {{schedule.slotTimeStr}}</span></span>
        </div>
        <div class="unavailable-wrapper" *ngIf="!memberSchedules?.memberSchedules[0]?.userTeams.length">
            <div class="icon"><img src="/assets/images/temp/calendar-cancel.svg" alt="no calendar invite" /></div>
            <span class="text grey" translate>label_unavailable</span>
          </div>
    </div>
</div>